import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

// needs to be synced with backend pageSize in lambdas/src/settings.js
// this is the way we determine whether or not to stop fetching
export const pageSize = 10;

/**
 * Paginated handler. This has the same dispatch semantics
 * as the main handler in src/api/apiHandlers.js but it
 * loops until we've grabbed all elements.
 */
export const mkPaginatedHandler = (fn, base, clear=true) => {
  function* handler(action) {
    yield put({type: `${base}_PENDING`});
    try {
      // always overwrite local stored data here, unless explicitly
      // asked to not do so
      if (clear) {
        yield put({type: `${base}_CLEARDATA`, payload: action.payload});
      }

      let payload = action.payload;
      let response = null;
      while (true) {
        response = yield call(fn, payload);
        if (!response.page.next) {
          yield put({type: `${base}_SUCCESSFUL`, payload: response});
          break;
        } else {
          yield put({type: `${base}_PAGE_SUCCESSFUL`, payload: response});
          payload.nextUrl = response.page.next;
        }
      }
    } catch (error) {
      yield put({
        type: `${base}_FAILED`,
        payload: {
          message: error.message,
          data: error.response ? error.response.data : {},
          statusCode: error.response ? error.response.status : null,
        }
      });
    }
  }

  function* watchHandler() {
    let takeFn = takeLatest;
    if (!clear) {
      takeFn = takeEvery;
    }
    yield takeFn(`${base}_REQUESTED`, handler);
  }
  return {
    handler: handler,
    watcher: watchHandler
  };
};





// WEBPACK FOOTER //
// ./src/api/paginatedHandler.js